import Vue from 'vue'
import VueLocalStorage from 'vue-ls'

const options = {
  namespace: 'vue_base_console_'
}

Vue.use(VueLocalStorage, options)



// WEBPACK FOOTER //
// ./src/plugins/localstorage.js